var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LegendaryChart',{attrs:{"loading":_vm.timeseries.loading,"resolved":_vm.timeseries.status.isResolved(),"timeseries":_vm.styledTimeseries,"time":_vm.timeseries.time,"height":_vm.height,"chart-kind":_vm.gridItem.params.chartKind,"connect-nulls":_vm.gridItem.params.connectNulls,"legend":_vm.legend}})
}
var staticRenderFns = []

export { render, staticRenderFns }